export const statusCodeMap = {
    followup: 'Follow Up Required',
    noaction: 'No Action',
    completed: 'Completed',
} as const

export const formatStatusCode = (statusCode: string | null | undefined): string => {
    if (!statusCode) {
        return ''
    }

    return (statusCodeMap as Record<string, string>)[statusCode] || ''
}
